(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ht-toast"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const toast = document.getElementById('ht-toast');
    const toastTitle = document.getElementById('ht-toast-title');
    const toastDesc = document.getElementById('ht-toast-desc');
    const toastIcon = document.getElementById('ht-toast-icon');
    const toastBtn = document.getElementById('ht-toast-btn');
    
    if (!toast) return;

    let toastTimeout;
    
    window.showHtToast = function(title, desc, isError = false) {
      toastTitle.innerText = title || (isError? 'Fehler' : 'In den Warenkorb gelegt!');
      toastDesc.innerText = desc || (isError? '' : 'Ihre Bestellung ist bereit.');
      
      if (isError) {
        toast.classList.add('ht-toast--error');
        toastIcon.querySelector('.icon-success').style.display = 'none';
        toastIcon.querySelector('.icon-error').style.display = 'block';
        if (toastBtn) toastBtn.style.display = 'none';
      } else {
        toast.classList.remove('ht-toast--error');
        toastIcon.querySelector('.icon-success').style.display = 'block';
        toastIcon.querySelector('.icon-error').style.display = 'none';
        if (toastBtn) toastBtn.style.display = 'block';
      }

      toast.classList.add('is-active');
      clearTimeout(toastTimeout);
      toastTimeout = setTimeout(() => {
        toast.classList.remove('is-active');
      }, 4.000);
    }
    
    document.querySelectorAll('a[href^="/cart/add"]').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const urlParams = new URLSearchParams(this.getAttribute('href').split('?')[1]);
        const variantId = urlParams.get('id');
        if (!variantId) {
          window.location.href = this.href;
          return;
        }
        
        const originalHtml = this.innerHTML;
        this.style.pointerEvents = 'none';
        this.innerHTML = '<span style="opacity:0.9;">Verfügbarkeit wird geprüft... ⏳</span>';
        
        setTimeout(() => {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }]
            })
          })
          .then(res => {
            if (!res.ok) throw new Error('Nicht auf Lager');
            return res.json();
          })
          .then(data => {
            this.innerHTML = '<span style="opacity:0.9;">Weiterleitung... 🔒</span>';
            window.showHtToast('Glückwunsch', 'Ihr Produkt wurde erfolgreich in den Warenkorb gelegt.');
            
            setTimeout(() => {
               window.location.href = '/cart';
            }, 1200); 
          })
          .catch(err => {
            this.innerHTML = originalHtml;
            this.style.pointerEvents = 'auto';
            window.showHtToast('Nicht auf Lager', 'Dieses Produkt ist nicht mehr verfügbar.', true);
          });
        }, 600); 
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
